/*
 * @Author: Nora Galvin
 * @Date: 2020-08-19 15:56:15
 * @Last Modified by: Felixx
 * @Last Modified time: 2021-07-13 11:24:50
 */

import type { TypeOption, TypeInteraction } from '../type';
/**
 * Single Interaction template
 * @param interaction interaction
 * @param $atom current atom DOM
 * @param options array options
 * @returns string
 */
export default (interaction: TypeInteraction, $atom: JQuery, options: Array<TypeOption>): string => {
  let optionsTemplate = '';
  options.forEach((e) => {
    if (e.type == 'group') {
      optionsTemplate += `<option class="gf-dropdown-label" data-type="group" value="${e.key}">${e.value}</option>`;
      e.options?.forEach((el) => {
        optionsTemplate += `<option class="gf-dropdown-item" value="${el.key}" ${el.default ? 'selected' : ''}>${
          el.value
        }</option>`;
      });
    } else {
      optionsTemplate += `<option class="gf-dropdown-item" value="${e.key}" ${e.default ? 'selected' : ''}>${
        e.value
      }</option>`;
    }
  });
  const key = `${interaction.key}_${interaction.type}_${$atom.attr('id')}`;
  return `
    <div class="interaction-item" data-interaction="${key}">
      <div class="interaction-head">
        <div class="interaction-info">
          <div class="interaction-name">
            <span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.5 6.08594C7.8236 5.76233 8.34827 5.76233 8.67187 6.08594L12.7324 10.1464C12.9276 10.3417 12.9276 10.6583 12.7324 10.8536L8.67187 14.9141C8.34827 15.2377 7.8236 15.2377 7.5 14.9141C7.1764 14.5905 7.1764 14.0658 7.5 13.7422L10.7422 10.5L7.5 7.25781C7.1764 6.93421 7.1764 6.40954 7.5 6.08594Z" fill="#F8F8F8"/>
              </svg>
            </span>
            <p>${interaction.name}</p>
          </div>
          <div class="interaction-desc">
            <p>${interaction.description}</p>
          </div>
        </div>
        <div class="interaction-action">
          <span class="delete">
            <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5.6875 0.25C4.92811 0.25 4.3125 0.865609 4.3125 1.625V2H3.0625H1.3125C1.03636 2 0.8125 2.22386 0.8125 2.5C0.8125 2.77614 1.03636 3 1.3125 3H2.5625V10.375C2.5625 11.1344 3.17811 11.75 3.9375 11.75H10.0625C10.8219 11.75 11.4375 11.1344 11.4375 10.375V3H12.6875C12.9636 3 13.1875 2.77614 13.1875 2.5C13.1875 2.22386 12.9636 2 12.6875 2H10.9375H9.6875V1.625C9.6875 0.865609 9.07189 0.25 8.3125 0.25H5.6875ZM8.6875 2V1.625C8.6875 1.41789 8.51961 1.25 8.3125 1.25H5.6875C5.48039 1.25 5.3125 1.41789 5.3125 1.625V2H8.6875ZM4.8125 3H3.5625V10.375C3.5625 10.5821 3.73039 10.75 3.9375 10.75H10.0625C10.2696 10.75 10.4375 10.5821 10.4375 10.375V3H9.1875H4.8125ZM5.6875 4.625C5.96364 4.625 6.1875 4.84886 6.1875 5.125V8.625C6.1875 8.90114 5.96364 9.125 5.6875 9.125C5.41136 9.125 5.1875 8.90114 5.1875 8.625V5.125C5.1875 4.84886 5.41136 4.625 5.6875 4.625ZM8.8125 5.125C8.8125 4.84886 8.58864 4.625 8.3125 4.625C8.03636 4.625 7.8125 4.84886 7.8125 5.125V8.625C7.8125 8.90114 8.03636 9.125 8.3125 9.125C8.58864 9.125 8.8125 8.90114 8.8125 8.625V5.125Z" fill="#F8F8F8"/>
            </svg>
          </span>
        </div>
      </div>
      <div class="interaction-content">
        <div class="interaction-section">
          <p class="title">Animation</p>
          <div class="control">
            <select>
              ${optionsTemplate}
            </select>
          </div>
        </div>
      </div>
    </div>
  `;
};
